"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchBillDetails = exports.useDownloadReports = exports.useFetchPaymentwiseReport = exports.useFetchDuplicateBillReport = exports.useFetchWriteOffReport = exports.useFetchCounterWiseReport = exports.useFetchUserWiseReport = exports.useFetchInventoryReport = exports.useFetchItemwiseReport = exports.useFetchDaywiseReport = exports.useFetchBillwiseReport = exports.useFetchOutletSummaryForOutlet = exports.useFetchOutletSummaryForFranchise = exports.useFetchOutletwiseSummary = exports.useFetchOutletSummary = exports.useFetchBusinessSumaryReport = exports.useFetchBusinessSumaryCurrentReport = void 0;
const react_redux_1 = require("react-redux");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const react_router_dom_1 = require("react-router-dom");
const reportsAction_1 = require("./reportsAction");
const reportsAction_2 = require("./reportsAction");
function useFetchBusinessSumaryCurrentReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const businessSummaryCurrentReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchBusinessSummaryCurrent'].loading);
    const businessSummaryCurrentReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchBusinessSummaryCurrent'].error);
    const businessSummaryCurrentReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchBusinessSummaryCurrent'].data);
    const businessSummaryCurrentReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchBusinessSummaryCurrent)(fetchPayload));
    });
    return {
        businessSummaryCurrentReportLoading,
        businessSummaryCurrentReportError,
        businessSummaryCurrentReportFetch,
        businessSummaryCurrentReportData
    };
}
exports.useFetchBusinessSumaryCurrentReport = useFetchBusinessSumaryCurrentReport;
function useFetchBusinessSumaryReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const businessSummaryReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchBusinessSummary'].loading);
    const businessSummaryReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchBusinessSummary'].error);
    const businessSummaryReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchBusinessSummary'].data);
    const businessSummaryReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_2.fetchBusinessSummary)(fetchPayload));
    });
    return {
        businessSummaryReportLoading,
        businessSummaryReportError,
        businessSummaryReportFetch,
        businessSummaryReportData
    };
}
exports.useFetchBusinessSumaryReport = useFetchBusinessSumaryReport;
function useFetchOutletSummary() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const outletSummaryLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletSummary'].loading);
    const outletSummaryError = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletSummary'].error);
    const outletSummaryData = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletSummary'].data);
    const outletSummaryFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchOutletSummary)(fetchPayload));
    });
    return {
        outletSummaryLoading,
        outletSummaryError,
        outletSummaryFetch,
        outletSummaryData
    };
}
exports.useFetchOutletSummary = useFetchOutletSummary;
function useFetchOutletwiseSummary() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const loading = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletwiseSummary'].loading);
    const error = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletwiseSummary'].error);
    const data = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletwiseSummary'].data);
    const fetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchOutletwiseSummary)(fetchPayload));
    });
    return {
        loading,
        error,
        fetch,
        data
    };
}
exports.useFetchOutletwiseSummary = useFetchOutletwiseSummary;
function useFetchOutletSummaryForFranchise() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const loading = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletSummaryForFranchise'].loading);
    const error = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletSummaryForFranchise'].error);
    const data = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletSummaryForFranchise'].data);
    const fetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchOutletwiseSummaryForFranchise)(fetchPayload));
    });
    return { loading, error, fetch, data };
}
exports.useFetchOutletSummaryForFranchise = useFetchOutletSummaryForFranchise;
function useFetchOutletSummaryForOutlet() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const loading = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletSummaryForOutlet'].loading);
    const error = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletSummaryForOutlet'].error);
    const data = (0, react_redux_1.useSelector)((state) => state['reports/fetchOutletSummaryForOutlet'].data);
    const fetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchOutletwiseSummaryForOutlet)(fetchPayload));
    });
    return { loading, error, fetch, data };
}
exports.useFetchOutletSummaryForOutlet = useFetchOutletSummaryForOutlet;
function useFetchBillwiseReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const billwiseReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchBillwiseReport'].loading);
    const billwiseReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchBillwiseReport'].error);
    const billwiseReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchBillwiseReport'].data);
    const billwiseReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchBillwiseReport)(fetchPayload));
    });
    return {
        billwiseReportLoading,
        billwiseReportError,
        billwiseReportFetch,
        billwiseReportData
    };
}
exports.useFetchBillwiseReport = useFetchBillwiseReport;
function useFetchDaywiseReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const daywiseReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchDaywiseReport'].loading);
    const daywiseReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchDaywiseReport'].error);
    const daywiseReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchDaywiseReport'].data);
    const daywiseReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchDaywiseReport)(fetchPayload));
    });
    return {
        daywiseReportLoading,
        daywiseReportError,
        daywiseReportFetch,
        daywiseReportData
    };
}
exports.useFetchDaywiseReport = useFetchDaywiseReport;
function useFetchItemwiseReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const itemwiseReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchItemWiseReport'].loading);
    const itemwiseReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchItemWiseReport'].error);
    const itemwiseReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchItemWiseReport'].data);
    const itemwiseReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchItemWiseReport)(fetchPayload));
    });
    return {
        itemwiseReportLoading,
        itemwiseReportError,
        itemwiseReportFetch,
        itemwiseReportData
    };
}
exports.useFetchItemwiseReport = useFetchItemwiseReport;
function useFetchInventoryReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const inventoryReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchInventoryReport'].loading);
    const inventoryReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchInventoryReport'].error);
    const inventoryReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchInventoryReport'].data);
    const inventoryReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchInventoryReport)(fetchPayload));
    });
    return {
        inventoryReportLoading,
        inventoryReportError,
        inventoryReportFetch,
        inventoryReportData
    };
}
exports.useFetchInventoryReport = useFetchInventoryReport;
function useFetchUserWiseReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userwiseReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchUserwiseReport'].loading);
    const userwiseReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchUserwiseReport'].error);
    const userwiseReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchUserwiseReport'].data);
    const userwiseReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchUserwiseReport)(fetchPayload));
    });
    return {
        userwiseReportLoading,
        userwiseReportError,
        userwiseReportFetch,
        userwiseReportData
    };
}
exports.useFetchUserWiseReport = useFetchUserWiseReport;
function useFetchCounterWiseReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const counterwiseReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchCounterWiseReport'].loading);
    const counterwiseReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchCounterWiseReport'].error);
    const counterwiseReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchCounterWiseReport'].data);
    const counterwiseReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchCounterWiseReport)(fetchPayload));
    });
    return {
        counterwiseReportLoading,
        counterwiseReportError,
        counterwiseReportFetch,
        counterwiseReportData
    };
}
exports.useFetchCounterWiseReport = useFetchCounterWiseReport;
function useFetchWriteOffReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const writeoffReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchWriteOffReport'].loading);
    const writeoffReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchWriteOffReport'].error);
    const writeoffReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchWriteOffReport'].data);
    const writeoffReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchWriteOffReport)(fetchPayload));
    });
    return {
        writeoffReportLoading,
        writeoffReportError,
        writeoffReportFetch,
        writeoffReportData
    };
}
exports.useFetchWriteOffReport = useFetchWriteOffReport;
function useFetchDuplicateBillReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const duplicateBillReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchDuplicateBillReport'].loading);
    const duplicateBillReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchDuplicateBillReport'].error);
    const duplicateBillReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchDuplicateBillReport'].data);
    const duplicateBillReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchDuplicateBillReport)(fetchPayload));
    });
    return {
        duplicateBillReportLoading,
        duplicateBillReportError,
        duplicateBillReportFetch,
        duplicateBillReportData
    };
}
exports.useFetchDuplicateBillReport = useFetchDuplicateBillReport;
function useFetchPaymentwiseReport() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const paymentwiseReportLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchPaymentwiseReport'].loading);
    const paymentwiseReportError = (0, react_redux_1.useSelector)((state) => state['reports/fetchPaymentwiseReport'].error);
    const paymentwiseReportData = (0, react_redux_1.useSelector)((state) => state['reports/fetchPaymentwiseReport'].data);
    const paymentwiseReportFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, reportsAction_1.fetchPaymentwiseReport)(fetchPayload));
    });
    return {
        paymentwiseReportLoading,
        paymentwiseReportError,
        paymentwiseReportFetch,
        paymentwiseReportData
    };
}
exports.useFetchPaymentwiseReport = useFetchPaymentwiseReport;
function useDownloadReports() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const downloadReportsLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchDownloadReport'].loading);
    const downloadReportsError = (0, react_redux_1.useSelector)((state) => state['reports/fetchDownloadReport'].error);
    const downloadReportsData = (0, react_redux_1.useSelector)((state) => state['reports/fetchDownloadReport'].data);
    const downloadReportsFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        const res = yield dispatch((0, reportsAction_1.fetchDownloadReport)(fetchPayload));
        return res;
    });
    return {
        downloadReportsLoading,
        downloadReportsError,
        downloadReportsFetch,
        downloadReportsData
    };
}
exports.useDownloadReports = useDownloadReports;
function useFetchBillDetails() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const billDetailsLoading = (0, react_redux_1.useSelector)((state) => state['reports/fetchBillDetails'].loading);
    const billDetailsError = (0, react_redux_1.useSelector)((state) => state['reports/fetchBillDetails'].error);
    const billDetailsData = (0, react_redux_1.useSelector)((state) => state['reports/fetchBillDetails'].data);
    const billDetailsFetch = (billId) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        const res = yield dispatch((0, reportsAction_1.fetchBillDetails)(billId));
        return res;
    });
    return {
        billDetailsLoading,
        billDetailsError,
        billDetailsFetch,
        billDetailsData
    };
}
exports.useFetchBillDetails = useFetchBillDetails;
